import { useCallback } from 'react';
import { matchRoutes, useLocation } from 'react-router';
import { routes } from '../Application/Routes';

function useRouteMatch() {

	const currentLocation = useLocation();

	/**
	 * Method used to determine if the parameter 'path' passed in is the current location of the application. 
	 * Returns true when the passed in 'path' was determined to be the current location, otherwise false.
	 */
	const isCurrentRoute = useCallback((path: string) => {

		// routes from the react-router are prefixed with the / where the consumer may not require it
		if (!path.startsWith("/")) {
			path = `/${path}`;
		}

		const match = matchRoutes(routes, currentLocation);

		return match && match.length > 0 && match.slice(-1)[0].pathname.localeCompare(path, 'en', { sensitivity: 'base' }) === 0;

	}, [currentLocation]);

	return { isCurrentRoute };
}

export default useRouteMatch;